// extracted by mini-css-extract-plugin
module.exports = {"cells":"styles_cells__1tFHI","cell":"styles_cell__3FCWH","cellContent":"styles_cellContent__HpAfs","cellPrice":"styles_cellPrice__1rTih"};